module.exports = __webpack_public_path__ + "img/copy.7699507f.svg";